var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-nosotros-trabaja"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"md":24,"xs":24,"data-aos":"fade-right"}},[_c('div',[_c('div',{staticClass:"trabajo-css",domProps:{"innerHTML":_vm._s(_vm.$t('trabaja_nosotros.titulo'))}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }